module.exports = __webpack_public_path__ + "img/product12-quanxian.07a6e118.svg";